import { render, staticRenderFns } from "./MarqueeMsg.vue?vue&type=template&id=1b1c9e70&scoped=true&"
import script from "./MarqueeMsg.vue?vue&type=script&lang=js&"
export * from "./MarqueeMsg.vue?vue&type=script&lang=js&"
import style0 from "./MarqueeMsg.vue?vue&type=style&index=0&id=1b1c9e70&lang=scss&scoped=true&"
import style1 from "./MarqueeMsg.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c9e70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
